import { useContext, useMemo } from "react"
import FlotiMapContext from "./context/context"
import { useTranslation } from "react-i18next"
import ButtonSelect from "../Input/ButtonSelect"
import Icon from "../Icon"
import { ICON } from "../Icon/data"
import { MAP_TYPES, MAP_VIEW_OPTIONS } from "./data"
import { setMapTile, setViewOptions } from "./context/actions"
import Input from "../Input"
import { MapOptions } from "./type"

export const useOptions = (options: MapOptions) => {
  const { t } = useTranslation()
  const { flotiMap, dispatch } = useContext(FlotiMapContext)
  const { viewOptions } = flotiMap

  const mapTypeSelector = useMemo(() => {
    return (
      <ButtonSelect
        label={(
          <>
            {t('Map type')}
            <Icon icon={ICON.GLOBE} />
          </>
        )}
        options={
          Object.keys(MAP_TYPES).reduce((obj, key) => {
            obj[key] = MAP_TYPES[key].label
            return obj
          }, {})
        }
        onChange={(id) => dispatch(setMapTile(id))}
        dropdownAlign="left"
        dropdownWidth={160}
      />
    )
  }, [dispatch, t])

  const viewOptionsSelector = useMemo(() => {
    return (
      <ButtonSelect
        closeOnSelection={false}
        dropdownWidth={210}
        label={(
          <>
            {t('View options')}
            <Icon icon={ICON.COG_VIEW} />
          </>
        )}
        options={
          Object.keys(MAP_VIEW_OPTIONS).reduce((obj, key) => {
            const { label, icon, isVisible } = MAP_VIEW_OPTIONS[key]
            if (isVisible(options)) {
              const value = viewOptions[key]
              obj[key] = (
                <div className="FlotiMap__options">
                  <div className="FlotiMap__options-label">
                    <Icon icon={icon} />
                    {label}
                  </div>
                  <Input
                    type="toggle"
                    size="s"
                    value={value}
                    onInput={(val) => dispatch(setViewOptions({ [key]: val }))}
                  />
                </div>
              )
            }
            return obj
          }, {})
        }
        onChange={(key) => dispatch(setViewOptions({ [key]: !viewOptions[key] }))}
        dropdownAlign="left"
      />
    )
  }, [dispatch, viewOptions, t, options])

  return {
    mapTypeSelector,
    viewOptionsSelector
  }
}
